import { z } from 'zod';

import { FeeId } from '../BrandedIds';
import { Payment } from '../loan/Payments';
import { BaseLoanEvent } from './BaseLoanEvent';
import { NachaPaymentInfo } from './NachaPaymentInfo';

export const CreateMultipleFeesPaymentEvent = BaseLoanEvent.extend({
  type: z.literal('createMultipleFeesPayment'),
  payment: Payment,
  feeIds: z.array(FeeId).min(1),
  disableEmail: z.boolean().optional(),
  nachaPayment: NachaPaymentInfo.optional(),
});
export type CreateMultipleFeesPaymentEvent = z.infer<typeof CreateMultipleFeesPaymentEvent>;
